module.exports = __webpack_public_path__ + "static/media/header_bg_3.f4db36fc.jpg";